package org.example.willfreightnew.components.sections

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.boxShadow
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.id
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.maxWidth
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.textAlign
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.add
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.silk.style.toAttrs
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import org.example.willfreightnew.HeadlineTextStyle
import org.example.willfreightnew.components.SectionTitle
import org.example.willfreightnew.components.layouts.PageLayoutData
import org.example.willfreightnew.components.models.Section
import org.example.willfreightnew.components.util.Constants.SECTION_WIDTH
import org.example.willfreightnew.pages.HeroContainerStyle
import org.example.willfreightnew.toSitePalette
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Div
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.compose.ui.modifiers.color

@InitRoute
fun initAboutPage(ctx: InitRouteContext) {
    ctx.data.add(PageLayoutData("Services"))
}

@Page
@Layout(".components.layouts.PageLayout")
@Composable
fun AboutSection() {
    Box(HeroContainerStyle.toModifier()) {
        Div(HeadlineTextStyle.toAttrs()) {
            Box(
                modifier = Modifier
                    .id(Section.About.id)
                    .maxWidth(SECTION_WIDTH.px)
                    .padding(top = 20.px, bottom = 100.px)
                    .backgroundColor(ColorMode.current.toSitePalette().background),
                contentAlignment = Alignment.Center
            ) {
                AboutContent()
            }
        }
    }
}

@Composable
fun AboutContent() {
    val breakpoint = rememberBreakpoint()
    Column(
        modifier = Modifier
            .fillMaxWidth()
            .margin(top = 15.px),
        horizontalAlignment = Alignment.CenterHorizontally
    ) {
        SectionTitle(
            modifier = Modifier
                .fillMaxWidth()
                .margin(bottom = 20.px)
                .textAlign(TextAlign.Center),
            section = Section.About,
            alignment = Alignment.CenterHorizontally
        )

        Column() {
            SpanText(" Founded in 1979 by Robert Hamilton, Will Freight Services Ltd has been offering a 'One-Stop-Shop' transport solution for local businesses in Northern Ireland and abroad. As Freight Forwarding specialists with over 40 years of experience in the industry, our knowledge & expertise is second to none.\n" +
                    "\n" +
                    " Utilizing our network of trusted partners, we offer unparalleled logistics solutions. Whether you require urgent same-day, or regular 24/48 Hr cost effective services, we offer a wide range of options that meet your particular needs.\n",
                Modifier
                    .color(ColorMode.current.toSitePalette().brand.primary)
                    .fontSize(20.px)
                    .fontWeight(FontWeight.Light)
                    .margin(top = 40.px)
                    .boxShadow(0.px, 0.px, 0.px, 0.px))
        }
    }
}